'use strict';
import { buildErrorMessageSummary, clearErrorSummaryMessage } from '../../../../../../../node_modules/@generalmedicalcouncil/loop/gmc-design-system/components/errorSummary/errorSummary';

const allForms = document.querySelectorAll('.c-form'),
    formSectionClass = '.c-form__section',
    formElementClass = '.c-form__element',
    formFieldsetClass = '.c-form__fieldset',
    formElementErrorClass = 'c-form__element--has-error',
    formFieldsetErrorClass = 'c-form__fieldset--has-error',
    formInputValidationErrorClass = 'input-validation-error',
    formFieldValidationErrorClass = '.field-validation-error';


function observeFormInputs(formInput) {
    const formInputsObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === 'attributes') {
                if (formInput.closest(formElementClass)) {
                    if (!formInput.classList.contains(formInputValidationErrorClass)) {
                        formInput.closest(formElementClass).classList.remove(formElementErrorClass)
                    }
                    else if (formInput.classList.contains(formInputValidationErrorClass)) {
                        formInput.closest(formElementClass).classList.add(formElementErrorClass)
                    }
                }
                else if (formInput.closest(formFieldsetClass)) {
                    if (!formInput.classList.contains(formInputValidationErrorClass)) {
                        formInput.closest(formFieldsetClass).classList.remove(formFieldsetErrorClass)
                    }
                    else if (formInput.classList.contains(formInputValidationErrorClass)) {
                        formInput.closest(formFieldsetClass).classList.add(formFieldsetErrorClass)
                    }
                }
            }
        });
    });

    // configuration of the observer
    const config = {
        attributes: true,
        attributeFilter: ['class']
    };

    // pass in the target node, as well as the observer options
    formInputsObserver.observe(formInput, config);
}

if (allForms) {
    allForms.forEach(form => {
        const allFormInputs = form.querySelectorAll("input, select, textarea");
        const formSubmitButton = form.querySelector('input[type="submit"]');

        form.setAttribute("novalidate", "")

        if (form.querySelectorAll(formSectionClass).length > 0) {
            let formSection = form.querySelectorAll(formSectionClass)

            formSection[0].setAttribute("data-form-section-first", "")

            formSection.forEach(section => {
                let formFieldset = section.querySelectorAll(formFieldsetClass)
                section.lastElementChild.setAttribute("data-form-section-last-child-element", "")

                // Loop through fieldsets within the form. This is needed because SC10 only adds the validation error class to the first checkbox input of a group, not all of them .
                formFieldset.forEach(fieldset => {
                    // Get the first checkbox field within the fieldset
                    const checkboxInput = fieldset.querySelector('.js-checkbox-input')
                    if (checkboxInput) {
                        observeFormInputs(checkboxInput);
                    }
                });
            });
        }

        for (var i = 0; i < allFormInputs.length; i++) {
            if (!allFormInputs[i].classList.contains('js-checkbox-input')) {
                observeFormInputs(allFormInputs[i]);
            }
        }

        formSubmitButton.addEventListener("click", () => {
            clearErrorSummaryMessage()
            setTimeout(function () {
                const errorMessages = form.querySelectorAll(formFieldValidationErrorClass);  
                if (errorMessages.length > 0) {
                    let currentErrorMessages = form.querySelectorAll(formFieldValidationErrorClass)
                    // Build the error summary, bringing it in to view with focus whilst also adding error text to the page title
                    buildErrorMessageSummary(currentErrorMessages)
                }
                else {
                    clearErrorSummaryMessage()
                }
            }, 0);
        })
    });
}